export { Identicon } from './identicon'
